"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var boolean_serialiser_1 = require("./../serialisers/boolean-serialiser");
var session_lock_acquisition_serialiser_1 = require("./../services/session-lock/session-lock-acquisition-serialiser");
var session_lock_request_serialiser_1 = require("./../services/session-lock/session-lock-request-serialiser");
exports.ACQUIRE_SESSION_LOCK = {
    id: 114,
    request: session_lock_request_serialiser_1.SessionLockRequestSerialiser,
    response: session_lock_acquisition_serialiser_1.SessionLockAcquisitionSerialiser
};
exports.RELEASE_SESSION_LOCK = {
    id: 116,
    request: session_lock_acquisition_serialiser_1.SessionLockAcquisitionSerialiser,
    response: boolean_serialiser_1.BooleanSerialiser
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/session-lock-services.js
// module id = 2015
// module chunks = 1